import { makeStyles } from '@mui/styles';
import Typography from 'apollo-react/components/Typography';
import React from 'react';
import { useSelector } from 'react-redux';

import { useTranslation } from '../../../../custom-hooks/useTranslation';
import { getEntityProp } from '../../../selectors/entity-designer.selectors';

const useStyles = makeStyles({
  rowLabel: {
    paddingTop: 8,
    paddingRight: 8,
    alignItems: 'center',
    width: 200,
  },
  rowColumn: {
    flex: 1,
    alignItems: 'center',
    '& div': {
      margin: 0,
    },
  },
  booleanValue: {
    paddingTop: 5,
  },
});

const BooleanControl = ({ label, prop }) => {
  const classes = useStyles();
  const translateString = useTranslation();
  const currentValue = useSelector((state) => getEntityProp(state, { prop }));
  const controlLabel = currentValue ? 'Yes' : 'No';

  return (
    <>
      <div className={classes.rowLabel}>
        <Typography>{translateString(label)}</Typography>
      </div>
      <div className={classes.rowColumn}>
        <div className={classes.booleanValue}>
          <Typography>{translateString(controlLabel)}</Typography>
        </div>
      </div>
    </>
  );
};

export default BooleanControl;
